module.exports = __webpack_public_path__ + "img/archive.15704b8f.svg";